import { NotificationGroupModel } from '@smarttask-common/src/lib/models/Notification/NotificationGroupModel';
import * as actions from './notification.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store} from '@ngrx/store';


export const notificationAdapter = createEntityAdapter<NotificationGroupModel>({
  selectId: x => x.id
});
export interface NotificationState extends EntityState<NotificationGroupModel>{
  selected_notification_id: string
};

export const initialState: NotificationState = notificationAdapter.getInitialState({
  selected_notification_id: undefined,
}); 


export function NotificationReducers(
  state: NotificationState = initialState,
  action: actions.NotificationActions
){
  switch(action.type){
    case actions.NotificationActionTypes.UPDATE_SELECTED_ID:
      state = {...state,selected_notification_id: action.selected_notification_id};
      //console.log(state);
      return state;

    case actions.NotificationActionTypes.ADD_NOTIFICATION: 
      return notificationAdapter.addOne(action.notification, {...state,selected_notification_id: state.selected_notification_id});

    case actions.NotificationActionTypes.ADD_NOTIFICATIONS:
      return notificationAdapter.addMany(action.notifications,{...state,selected_notification_id: state.selected_notification_id});

    case actions.NotificationActionTypes.UPSERT_NOTIFICATION:
      return notificationAdapter.upsertOne(action.notification,{...state,selected_notification_id: state.selected_notification_id});
      
    case actions.NotificationActionTypes.UPSERT_NOTIFICATIONS:
      return notificationAdapter.upsertMany(action.notifications,{...state,selected_notification_id: state.selected_notification_id});
  
    case actions.NotificationActionTypes.UPDATE_NOTIFICATION:
      return notificationAdapter.updateOne(action.notification,{...state,selected_notification_id: state.selected_notification_id});

    case actions.NotificationActionTypes.UPDATE_NOTIFICATIONS:
      return notificationAdapter.updateMany(action.notifications,{...state,selected_notification_id: state.selected_notification_id});

    case actions.NotificationActionTypes.DELETE_NOTIFICATION:
      // if(state.selected_notification_id == action.id){
      //   state.selected_notification_id = undefined;
      // }
      return notificationAdapter.removeOne(action.id,{...state,selected_notification_id: state.selected_notification_id});

    case actions.NotificationActionTypes.DELETE_NOTIFICATIONS:
      // if(action.ids.indexOf(state.selected_notification_id) > -1){
      //   state.selected_notification_id = undefined;
      // }
      return notificationAdapter.removeMany(action.ids,{...state,selected_notification_id: state.selected_notification_id});

    case actions.NotificationActionTypes.DELETE_ALL_NOTIFICATIONS:
      return notificationAdapter.removeMany(action.ids,{...state,selected_notification_id: state.selected_notification_id});

    case actions.NotificationActionTypes.DELETE_ALL:
      state.selected_notification_id = undefined;
      return notificationAdapter.removeAll(state);

    default:
      return state;
  }
}

export const getNotificationState = createFeatureSelector<NotificationState>('notification');

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = notificationAdapter.getSelectors(getNotificationState);

const getSelectedNotificationIdState = (state: NotificationState) => { 
  return state.selected_notification_id
};
export const getSelectedNotificationId = createSelector(getNotificationState, getSelectedNotificationIdState);

export const getSelectedNotification = createSelector(getNotificationState, (state: NotificationState)=>{
  if(state.selected_notification_id == undefined){
    return undefined;
  }
  return state.entities[state.selected_notification_id];
})

